<sgt-multi-select
  [options]="options"
  [settings]="settings"
  [(ngModel)]="setoresGep"
  (ngModelChange)="onChangeSetoresGep()"
  (search)="onSearch()">
</sgt-multi-select>
